import { PageDefinition } from "./pageDefinition.types";
import { automationDashboardPageDefinition } from "./automationDashboard/automationDashboardPageDefinition";
import { blacklistPageDefinition } from "./blacklist/blacklistPageDefinition";
import { dataImportPageDefinition } from "./dataImport/dataImportPageDefinition";
import { helpPageDefinition } from "./help/helpPageDefinition";
import { journeyPlannerPageDefinition } from "./journeyPlanner/journeyPlannerPageDefinition";
import { searchPageDefinition } from "./search/searchPageDefinition";
import { settingsPageDefinition } from "./settings/settingsPageDefinition";
import { warehouseApplicationsPageDefinition } from "./warehouseApplications/warehouseApplicationsPageDefinition";

/**
 * Every page that is neither a record nor a list. Adding one is its definition
 * and panels in their own folder, plus an entry here.
 */
export const pageDefinitions: PageDefinition[] = [
  automationDashboardPageDefinition,
  blacklistPageDefinition,
  dataImportPageDefinition,
  helpPageDefinition,
  journeyPlannerPageDefinition,
  searchPageDefinition,
  settingsPageDefinition,
  warehouseApplicationsPageDefinition,
];

export function getPageDefinitionByPath(path: string) {
  return pageDefinitions.find((definition) => definition.path === path);
}
